var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (model, view) {var items = model.items;
var selectedItem = model.selectedItem;
var focusedItem = model.focusedItem;
var topClasses = model.topClasses;
var itemClasses = model.itemClasses;

pug_mixins["buttons"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
var selected = val.id == selectedItem;
var focusedOrSelectedOrFirst = (focusedItem && val.id === focusedItem)
  || (!focusedItem && val.id === selectedItem)
  || (!focusedItem && !selectedItem && index === 0);
var disabled = view.isItemDisabled(val.id);
var mergedItemClasses = itemClasses
  .concat(selected ? ['active'] : [])
  .concat(disabled ? ['disabled'] : []);
var aAttributes = {
  tabIndex: focusedOrSelectedOrFirst ? '0' : '-1',
  'data-focus-id': val.id,
  'data-id': val.id
};
if (!disabled) {
  aAttributes.href = '#';
}

pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([mergedItemClasses], [true]), false, true)+pug.attr("aria-pressed", selected, true, true)+" role=\"presentation\""+pug.attr("aria-disabled", disabled, true, true)) + "\u003E\u003Ca" + (pug.attrs(aAttributes, true)) + "\u003E" + (pug.escape(null == (pug_interp = val.text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
var selected = val.id == selectedItem;
var focusedOrSelectedOrFirst = (focusedItem && val.id === focusedItem)
  || (!focusedItem && val.id === selectedItem)
  || (!focusedItem && !selectedItem && index === 0);
var disabled = view.isItemDisabled(val.id);
var mergedItemClasses = itemClasses
  .concat(selected ? ['active'] : [])
  .concat(disabled ? ['disabled'] : []);
var aAttributes = {
  tabIndex: focusedOrSelectedOrFirst ? '0' : '-1',
  'data-focus-id': val.id,
  'data-id': val.id
};
if (!disabled) {
  aAttributes.href = '#';
}

pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([mergedItemClasses], [true]), false, true)+pug.attr("aria-pressed", selected, true, true)+" role=\"presentation\""+pug.attr("aria-disabled", disabled, true, true)) + "\u003E\u003Ca" + (pug.attrs(aAttributes, true)) + "\u003E" + (pug.escape(null == (pug_interp = val.text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cul" + (pug.attr("class", pug.classes(["pill-control",topClasses], [false,true]), false, true)) + "\u003E";
pug_mixins["buttons"]();
pug_html = pug_html + "\u003C\u002Ful\u003E";}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return pug_html;};
module.exports = template;